<template>
    <layout title="Member Files">
        <settings-layout>
            <div class="px-8">
                <div v-if="saving" class="animate-pulse rounded-md bg-blue-50 p-4 mb-4">
                    <div class="flex items-center justify-center">
                        <p class="text-sm text-blue-700">
                            Uploading...
                        </p>
                    </div>
                </div>
                <div class="flex items-center">
                    <h3 class="mr-2 flex-none">Choose Member:</h3>
                    <div class="flex-grow">
                        <select v-model="selectedUser" id="member" name="member" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                            <option v-for="member in users" v-bind:value="member">{{ member.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div v-if="selectedUser.name" class="px-8 mt-8 pt-8">
                <div class="flex justify-between items-center">
                    <div class="font-semibold text-lg">
                        Member Files
                    </div>

                    <label class="cursor-pointer -ml-px relative flex items-center px-4 py-2 border text-sm font-medium rounded-md text-blue-50 bg-blue-500 hover:bg-dark-color focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
                        <svg class="w-6 h-6 mr-1 text-blue-100" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                        <span>Add New File</span>
                        <input multiple @change="onChange" ref="file" class="hidden" type="file" name="files">
                    </label>
                </div>
                <div class="flex flex-col mt-4">
                    <div class="-my-2 sm:-mx-6 lg:-mx-8">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow border-b border-gray-200 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th @click="sortBy('display_name')" :class="{'font-extrabold' : sortKey === 'display_name' }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            <div class="cursor-pointer flex items-center justify-between">
                                                <span>File Name</span>
                                                <span v-if="sortKey === 'display_name'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                            </div>
                                        </th>
                                        <th @click="sortBy('updated_at')" :class="{'font-extrabold' : sortKey === 'updated_at' }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            <div class="cursor-pointer flex items-center justify-between">
                                                <span>Updated At</span>
                                                <span v-if="sortKey === 'updated_at'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                            </div>
                                        </th>

                                        <th scope="col" class="relative px-6 py-3">
                                            <span class="sr-only">Edit</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, idx) in sortedMemberFiles" :class="{ 'bg-white' : idx % 2 === 0, 'bg-gray-50' : idx % 2 !== 0, 'bg-blue-50' : showMenu === item.id }">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            <a :href="`/storage/${item.name }`" target="_blank">{{ item.display_name }}</a>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                            {{ item.updated_at | niceTimestamp }}
                                        </td>
                                        <td class="px-6 py-4 align-top text-right text-sm font-medium">

                                            <div class="relative inline-block text-left">
                                                <div>
                                                    <button @click="setShowMenu(item.id)" class="w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none" id="options-menu" aria-haspopup="true" aria-expanded="true">
                                                        <span class="sr-only">Open options</span>
                                                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div v-if="item.id === showMenu" class="origin-top-right absolute z-10 right-0 top-0 mr-8 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                                                    <div class="py-1 border-t border-gray-100" role="none">
                                                        <remove-member-file @close-menu="showMenu = null" :item="item"></remove-member-file>
                                                    </div>
                                                </div>
                                            </div>

                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </settings-layout>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import SettingsLayout from "./SettingsLayout"
import RemoveMemberFile from '@/Components/MemberFiles/RemoveMemberFile'

export default {
    components: {SettingsLayout, Layout, RemoveMemberFile },
    metaInfo() {
        return {
            title: `Settings`,
        }
    },
    props: {
        users: {
            type: Array,
            default: [],
        },
        selectedUserReturn: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            saving: false,
            success: false,
            selectedUser: { files: [] },
            showMenu: null,
            sortKey: 'updated_at',
            sortOrder: 'desc',
            fileList: [],
        }
    },
    mounted() {
        if (this.selectedUserReturn) {
            this.selectedUser = this.selectedUserReturn
        }
    },
    methods: {
        setShowMenu(id) {
            this.showMenu = this.showMenu === id ? null : id
        },
        sortBy(key) {
            this.sortKey = key
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
                const comparison = a[key].toString().localeCompare(b[key].toString());

                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        },
        onChange() {
            let data = new FormData()
            data.append('user_id', this.selectedUser.id)
            this.fileList = [...this.$refs.file.files]
            this.fileList.forEach(file => data.append(`importFiles[]`, file))
            this.$inertia.post(this.route('settings.files.store'), data,
                {
                    onStart: () => this.saving = true,
                    onFinish: () => this.saving = false,
                    onSuccess: () => this.saving = false
                }
            )
        }
    },
    computed: {
        sortedMemberFiles() {
            return this.selectedUser.files.sort(
                this.compareValues(this.sortKey, this.sortOrder)
            )
        }
    },
    watch: {
        selectedUserReturn() {
            if (this.selectedUserReturn > 0) {
                this.selectedUser = this.users.find(user => user.id === parseInt(this.selectedUserReturn))
                this.selectedUserReturn = null
            }
        },
        users: {
            deep: true,
            handler() {
                if (this.selectedUserReturn > 0) {
                    this.selectedUser = this.users.find(user => user.id === parseInt(this.selectedUserReturn))
                }
            }
        }
    }
}
</script>
